<template>
  <div>
    <md-card-content>
      <form>
        <md-autocomplete
          v-if="!local['default_localization']"
          v-model="local.country"
          :class="$v.local.country.$error && 'md-invalid invalid-field'"
          :md-options="countriesOptions"
          @md-selected="onCountryPicked"
        >
          <label>Country</label>
          <span class="md-error">Field must not be empty</span>
        </md-autocomplete>

        <md-field>
          <label>Name</label>
          <md-input v-model="local.name" />
        </md-field>

        <md-field :class="$v.local.amount.$error && 'md-invalid invalid-field'">
          <label>Amount</label>
          <md-input v-model="local.amount" />
          <span class="md-error">Field must be an integer</span>
        </md-field>

        <md-autocomplete
          v-model="local.currency"
          :md-options="currencyCodes.map(c => c.name)"
          @md-selected="onCurrencyPicked"
        >
          <label>Currency</label>
        </md-autocomplete>

        <p>Best Price</p>
        <i>Highlight the product to be the best price among anothers</i>
        <div />
        <md-switch v-model="local['best_price']" />

        <md-field>
          <label>Duration</label>
          <md-input
            v-model="local.duration"
            @change="onDurationChange"
          />
          <span class="md-suffix">hours</span>
          <span class="md-helper-text">{{ durationHelperText }}</span>
        </md-field>


        <md-subheader class="no-indent-subheader">
          Data
        </md-subheader>
        <custom-data-form
          v-for="data in Object.entries(local.data)"
          :key="data[0]"
          :data="data"
          :index="data[0]"
          @update="onDataUpdate"
        />

        <md-subheader class="no-indent-subheader">
          Benefits
        </md-subheader>
        <custom-data-form
          v-for="(benefit, index) in local.benefits"
          :key="index"
          :is-benefit="true"
          :data="['title', benefit.title]"
          :icon="benefit['icon_url']"
          :index="index"
          @update="onBenefitsUpdate"
          @delete-benefit="deleteBenefit(index)"
        />
        <md-button
          class="md-accent md-plain add-benefit-button"
          @click.native="addBenefit"
        >
          Add benefit
        </md-button>
      </form>
    </md-card-content>

    <md-card-actions class="card-action-container">
      <md-button
        v-if="!local['default_localization']"
        class="md-icon-button md-raised md-accent delete-button"
        @click.native="showDeletionDialog"
      >
        <md-icon>delete</md-icon>
      </md-button>

      <md-button
        type="submit"
        class="md-primary"
        :disabled="loadingSubmission"
        @click.native="submitLocal"
      >
        <span v-if="!loadingSubmission">Save</span>
        <md-progress-spinner
          v-else
          :md-diameter="15"
          :md-stroke="3"
          md-mode="indeterminate"
        />
      </md-button>
    </md-card-actions>

    <md-dialog-confirm
      :md-active.sync="isDeletionDialogActive"
      :md-title="`Delete ${local.name } localization?`"
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-cancel="hideDeletionDialog"
      @md-confirm="deleteLocal"
    />
  </div>
</template>
<script>
import {countryOptions, countryNameToCode} from "../../assets/countries_iso/all-iso-codes";
import {currencyCodes} from "../../assets/countries_iso/currency-codes";
import CustomDataForm from "./CustomDataForm";
import {required, integer, requiredIf} from "vuelidate/lib/validators";

export default {
  components: {
    CustomDataForm
  },
  props: {
    localization: { type: Object, required: true },
    index: { type: Number, required: true }
  },
  data() {
    const local = this.$props.localization;
    // if there is a null-value property, replace it with a default object
    Object.entries(local.data).forEach(([key, value]) => {
      if (!value) {
        local.data[key] = {amount: 0, currency: ""};
      }
    });

    // hiding deprecated fields
    delete local.data.price_per_month;
    delete local.data.total_savings;
    delete local.data.discount_amount_in_currency;
    delete local.data.total_order_amount;

    return {
      local,
      loadingSubmission: false,
      isDeletionDialogActive: false,

      countriesOptions: countryOptions,
      countryNameToCode: countryNameToCode,
      currencyCodes,

      durationHelperText: ""
    };
  },
  mounted() {
      this.onDurationChange();
  },
  methods: {
    onBenefitsUpdate({index, newValue, icon}) {
      this.local.benefits[index].title = newValue;
      this.local.benefits[index]["icon_url"] = icon;
    },
    onDataUpdate({index, newValue}) {
      this.local.data[index] = newValue;
    },
    submitLocal() {
      this.$v.$touch();
      if (this.$v.local.$invalid) {
        return;
      }

      this.loadingSubmission = true;

      // deletes all data entries, where key or value is absent
      // this.local.data = Object.fromEntries(
      //     Object.entries(this.local.data).map(
      //         ([key,data]) => [key, Object.fromEntries(
      //             Object.entries(data).filter(
      //                 ([k, v]) => k && v
      //             )
      //         )]
      //     )
      // );
      this.local.benefits = this.local.benefits.filter(
          b => b["icon_url"] || Object.entries(b.title).some(
              ([key, value]) => key && value
          )
      );

      this.$http[this.local.id ? "put" : "post"](
          "/v1/admin/store/product-localization",
          {"product_localization": this.local}
      )
          .then(res => {
            this.loadingSubmission = false;
            console.log(res);
          })
          .catch(err => console.error(err));
    },
    onCountryPicked(countryName) {
      this.local.country = this.countryNameToCode[countryName];
    },
    onCurrencyPicked(currencyName) {
      this.local.currency = this.currencyCodes.find(c => c.name === currencyName).code;
    },
    showDeletionDialog() {
      this.isDeletionDialogActive = true;
    },
    hideDeletionDialog() {
      this.isDeletionDialogActive = false;
    },
    deleteLocal() {
      if (this.local.id) {
        this.$http.delete(`/v1/admin/store/product-localization/${this.local.id}`)
            .then(res => console.log(res))
            .catch(err => console.log(err));
      }
      this.$emit("deleteLocal", this.$props.index);
    },
    addBenefit() {
      this.local.benefits.push({
        "title": {},
        "icon_url": ""
      });
    },
    deleteBenefit(index) {
      this.local.benefits.splice(index, 1);
    },
    onDurationChange() {
      const days = this.local.duration / 24;

      if (days < 1) {
          this.durationHelperText = "";
          return;
      }

      const years = (days / 365).toFixed(2);
      const months = (days / 30).toFixed(2);
      const weeks = (days / 7).toFixed(2);

      if (years >= 1) {
          this.durationHelperText = `≈${years} years`;
      } else if (months >= 1) {
        this.durationHelperText = `≈${months} months`;
      } else if (weeks >= 1) {
        this.durationHelperText = `≈${weeks} months`;
      } else {
        this.durationHelperText = `≈${days} days`;
      }
    }
  },
  validations: {
    local: {
      country: {
        required: requiredIf(function () {
          return !this.local["default_localization"];
        })
      },
      amount: {
        required,
        integer
      },
      duration: {
        required,
        integer
      }
    }
  }
};
</script>
<style scoped lang="scss">
.invalid-field {
  color: #ff1745;

  input, label {
    color: #ff1745 !important;
  }
}

.invalid-field:before {
  background-color: #ff1745 !important;
}

.add-benefit-button {
  margin: 0 auto;
  display: block;
}

.no-indent-subheader {
  padding-left: 0;
}

.card-action-container {
  justify-content: space-between !important;
}

.delete-button {
  background-color: #ff5252 !important;
  padding: 10px 0;
  margin: auto 0;
}
</style>
